import script from "./passwordChangePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./passwordChangePopup.vue?vue&type=script&setup=true&lang=ts"

import "./passwordChangePopup.vue?vue&type=style&index=0&id=3f2ca5b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2ca5b0"]])

export default __exports__